import React, {Component} from 'react'
import {connect} from 'react-redux'
import { css } from 'emotion'
import {withRouter} from 'react-router-dom'
import SprintName from '../components/SprintName'
import Timestamp from './Timestamp'
import { has_permission } from '../actions/Users'
import { getSprintSnapshot, ensureSprintSnapshotsLoaded } from '../actions/SprintSnapshots'
import { ensureUsersLoaded } from '../actions/Users'
import { ensureTagsLoaded } from '../actions/Tags'
import { ensureIssuesLoaded } from '../actions/Issues'
import { ensureSprintsLoaded } from '../actions/Sprints'
import BreakdownSummary from './BreakdownSummary'
import SprintStateSummary from './SprintStateSummary'
import CostSummary from './pure/CostSummary'
import SprintBreakdown from './pure/SprintBreakdown'
import ProjectInvoices from './pure/ProjectInvoices'
import SprintBudgets from './pure/SprintBudgets'
import TimeSummary from './pure/TimeSummary'
import EstimateSummary from './pure/EstimateSummary'
 
class SprintSnapshotPage extends Component {

    componentDidMount() {
        this.refresh()
    }

    componentWillReceiveProps(new_props) {
        if ( new_props.sprint_snapshot_id !== this.props.sprint_snapshot_id ||
             new_props.sprint_snapshot.id !== this.props.sprint_snapshot.id ) {
            this.refresh(new_props)
        }
    }

    refresh(these_props) {
        const props = these_props || this.props
        const { dispatch, sprint_snapshot_id, sprint_snapshot } = props
        dispatch(ensureSprintSnapshotsLoaded([sprint_snapshot_id]))
        if ( sprint_snapshot.affected_entities ) {
            dispatch(ensureUsersLoaded(sprint_snapshot.affected_entities.all_user_ids))
            dispatch(ensureTagsLoaded(sprint_snapshot.affected_entities.all_tag_ids))
            dispatch(ensureIssuesLoaded(sprint_snapshot.affected_entities.all_issue_ids))
            dispatch(ensureSprintsLoaded(sprint_snapshot.affected_entities.all_sprint_ids))
        }
    }

    renderSnapshot() {
        const { sprint_snapshot, sprint_id } = this.props
        return (
            <div className={css`margin-left:20px`}>
              <h1>
                Snapshot {sprint_snapshot.description} taken on
                <Timestamp value={sprint_snapshot.created_at} format="dateshort-time" />
              </h1>
              { sprint_snapshot && sprint_snapshot.cost_summary &&
                <div>
                  <h2>State summary</h2>
                  <SprintStateSummary sprint_id={sprint_id}
                                      optional_cost_summary={sprint_snapshot.cost_summary} />
                  <br/>
                  <h2>Cost summary</h2>
                  <CostSummary cost_summary={sprint_snapshot.cost_summary} />
                  <br/>
                  <h2>Sprint budgets</h2>
                  <SprintBudgets project_statement={sprint_snapshot.project_statement} />
                  <br/>
                  <h2>Time summary</h2>
                  <TimeSummary time_summary={sprint_snapshot.time_summary}
                               show_heading={true}
                               sprint_id={sprint_id}
                               use_live_data_where_possible={false}
                  />
                  <br/>
                  <h2>Breakdown</h2>  
                  <SprintBreakdown project_statement={sprint_snapshot.project_statement}
                                   use_live_data_where_possible={false} />
                  <br/>
                  <h2>Invoices</h2>  
                  <ProjectInvoices project_statement={sprint_snapshot.project_statement} />
                  <br/>
                  <h2>Estimate time summary</h2>
                  <EstimateSummary estimate_time_summary={sprint_snapshot.estimate_time_summary} />
                  <br/>
                  <h2>Breakdown summary</h2>  
                  <BreakdownSummary summary={sprint_snapshot.cost_summary.breakdown} />
                </div>
              }
            </div>
        )
    }
    
    render() {

        const { sprint_id, sprint_snapshot } = this.props
        
        return (
            <div>
              <h2>
                <SprintName sprint_id={sprint_id} />
              </h2>
              <div>
                { sprint_snapshot && this.renderSnapshot() }
              </div>
            </div>
        )
    }
}

function mapStateToProps(state, props) {
    const sprint_snapshot_id = props.match.params.snapshotId
    const sprint_snapshot = getSprintSnapshot(state, sprint_snapshot_id) || {}
    const sprint_id = sprint_snapshot && sprint_snapshot.sprint_id
    const project_id = sprint_snapshot && sprint_snapshot.project_id
    const can_view_budget = project_id && has_permission(state, project_id, 'has_view_budget')
    const can_view_commission = can_view_budget
    
    return {
        sprint_snapshot_id,
        sprint_snapshot,
        project_id,
        sprint_id,
        can_view_budget,
        can_view_commission
    }
}

export default withRouter(connect(mapStateToProps)(SprintSnapshotPage))



// WEBPACK FOOTER //
// ./src/components/SprintSnapshot.js